
import { Dexie } from 'Dexie';
import { ActionTableColumn, DexieActionTable } from './schema/action';
import { DexiePublicationTable, PublicationTable, PublicationTableColumn } from './schema/publication';
import { DexiePublicationFilesTable, PublicationFileTable, PublicationFileTableColumn } from './schema/publicationFile';
import FDBFactory from 'fake-indexeddb/lib/FDBFactory';
import FDBKeyRange from 'fake-indexeddb/lib/FDBKeyRange';

export const actionDatabase = new Dexie('action-database-v1', {
  //indexedDB: new FDBFactory,
  //IDBKeyRange: FDBKeyRange, // Mocking IDBKeyRange
}) as Dexie & {
  action: DexieActionTable,
  publication: DexiePublicationTable,
  publicationFile: DexiePublicationFilesTable
};

actionDatabase.version(1).stores({
  action: ActionTableColumn,
  publication: PublicationTableColumn,
  publicationFile: PublicationFileTableColumn
});
